import RangeSlider from "./range";
import {
	findID,
	listener,
	normalizeData,
	getWordForm,
	mergeDeepObject,
	findAll
} from "../../../../../modules/vegas/js/util";

const minPrice = 50000;
const maxExecute = 99;
const minExecute = 2;

const Calculator = {
	button: null,
	onInit: function () {
		this.button = document.querySelector('[data-vg-toggle="calc"]');
		this.calculate(this.getElements());
	},

	onChange: function () {
		this.calculate(this.getElements());
	},

	getElements: function () {
		let $inputs = [...findAll('[data-calculate]')].filter((el) => el.tagName !== 'DIV'),
			params = {};

		if ($inputs.length) {
			$inputs.forEach(function (element) {
				switch (element.dataset.calculate) {
					case 'type': params = mergeDeepObject(params, Calculator.setType.on(element)); break;
					case 'square': params = mergeDeepObject(params, Calculator.setSquare.on(element)); break;
					case 'width': params = mergeDeepObject(params, Calculator.setWith.on(element)); break;
				}
			});
		}

		return params;
	},

	calculate: function (params) {
		let price = (params.width.value - params.width.min) / params.width.step  *  params.width.price + params.square.price,
			total = price * params.square.value,
			expense = (params.square.value * params.width.value * params.type.weight) / 1000;

		if (params.square.value >= minExecute && params.square.value <= maxExecute) {
			let sPrice = ((params.square.value - 1) * params.square.price) + ((params.width.value - params.width.min) / params.width.step  *  params.width.price);
			price = (sPrice + minPrice) / params.square.value;
			total = minPrice + sPrice
		}

		this.setDataTotal({
			price: price,
			total: total,
			expense: expense
		})
	},

	setDataTotal: function (totals) {
		let {expense, price, total} = totals,
			formantExpense = new Intl.NumberFormat('ru').format(expense),
			formatPrice = new Intl.NumberFormat('ru', {style: 'currency', currency: 'RUB', minimumFractionDigits: 0}).format(price),
			formatTotal = new Intl.NumberFormat('ru', {style: 'currency', currency: 'RUB', minimumFractionDigits: 0}).format(total);

		document.querySelector('[data-calculate-rate]').innerHTML = formantExpense + ' ' + getWordForm(Math.trunc(expense), ['тонна', 'тонны', 'тонн']);
		document.querySelector('[data-calculate-price]').innerHTML = formatPrice;
		document.querySelector('[data-calculate-result]').innerHTML = formatTotal;
		document.querySelector('[name="calc_rate"]').setAttribute('value', formantExpense);
		document.querySelector('[name="calc_price"]').setAttribute('value', formatPrice);
		document.querySelector('[name="calc_result"]').setAttribute('value', formatTotal);

		if(total < 1) {
			this.button.classList.add('disabled');
			this.button.setAttribute('disabled', 'disabled');
		} else {
			this.button.classList.remove('disabled');
			this.button.removeAttribute('disabled');
		}
	},

	setType: {
		params: {
			title: '',
			price: 0,
			weight: 0,
			value: ''
		},
		on: function (element) {
			const _this = this;
			let selected = element.options[element.selectedIndex];

			_this.params.value =   normalizeData(selected.value);
			_this.params.price =  normalizeData(selected.dataset.price);
			_this.params.weight = normalizeData(selected.dataset.weight);
			_this.params.title =  normalizeData(element.dataset.title);

			return {
				type: _this.params
			}
		}
	},

	setSquare: {
		params: {
			title: '',
			price: 0,
			value: 0,
		},
		on: function (element) {
			const _this = this;

			_this.params.ranges  = normalizeData(element.dataset.price);
			_this.params.title  = normalizeData(element.dataset.title);
			_this.params.value = normalizeData(element.value);

			if (!_this.params.value || _this.params.value < 0) {
				_this.params.value = 0;
			}

			_this.params.ranges.forEach(function (range) {
				if (_this.params.value >= range.min && _this.params.value <= range.max) {
					_this.params.price = range.price;
				} else if (_this.params.value === 1) {
					_this.params.price = minPrice;
				}
			});

			return {
				square: _this.params
			}
		}
	},

	setWith: {
		params: {
			title: '',
			price: 0,
			value: 0,
		},
		on: function (element) {
			const _this = this;

			_this.params.value = normalizeData(element.getAttribute('value'));
			_this.params.price = normalizeData(element.dataset.price);
			_this.params.title = normalizeData(element.dataset.title);
			_this.params.min = normalizeData(element.getAttribute('min'));
			_this.params.step = normalizeData(element.getAttribute('step'));

			return {
				width: _this.params
			}
		}
	}
}

function listeners() {
	listener('change', '#calc_type', function (el, event) {
		event.preventDefault();
		Calculator.onChange();
	});

	listener('keyup', '#calc_square', function (el, event) {
		event.preventDefault();
		Calculator.onChange();
	})

	listener('change', '#calc_square', function (el, event) {
		event.preventDefault();
		Calculator.onChange();
	})

	listener('click', '[data-vg-toggle="calc"]', function (el, event) {
		event.preventDefault();

		document.getElementById('calc-form').querySelectorAll('.show').forEach(function (element) {
			element.classList.remove('show');
			element.classList.remove('fade');
		})

		let target = el.dataset.target;
		document.querySelector(target).classList.add('show');

		setTimeout(() => {
			document.querySelector(target).classList.add('fade');
		}, 50)
	})
}

function onReady() {
	let calcType = findID('calculator');
	if (calcType) {
		let $inputRangeSlide = document.getElementById('range-slider'),
			$slider = new RangeSlider('[data-range-container]', {
				value: normalizeData($inputRangeSlide.getAttribute('value')) || 1,
				min:   normalizeData($inputRangeSlide.getAttribute('min')) || 1,
				max:   normalizeData($inputRangeSlide.getAttribute('max')) || 10,
				step:  normalizeData($inputRangeSlide.getAttribute('step')) || 1,
			});
		$slider.initial();
		$slider.setOnSlide(function () {
			$inputRangeSlide.setAttribute('value', $slider.getValue());
			Calculator.onChange();
		})

		Calculator.onInit();
	}
}

document.addEventListener('DOMContentLoaded', listeners);
document.addEventListener('DOMContentLoaded', onReady);
onTurboRender(onReady);
